// By default, liquid container adds a transform which breaks any fixed or
// sticky positioned elements under it. To work around it, we need to reset
// transforms after the transition is done.
//
// More at: https://github.com/ember-animation/liquid-fire/issues/597
//
// The same fix is applied to `app/transitions/to-left-with-cleanup'. This is
// used in `app/transitions.js`.
export default function (oldView, insertNewView) {
  return this.lookup('to-right')
    .call(this, oldView, insertNewView, 'y', -1)
    .then(function () {
      let container = document.querySelector('.liquid-container');
      if (container) {
        container.style.transform = 'initial';
      }

      let child = document.querySelector('.liquid-child');
      if (child) {
        child.style.transform = 'initial';
      }
    });
}
